import React, { useEffect } from 'react';
import styles from './BusinessInfoContent.module.scss';
import OrganizationForm from 'components/common/OrganizationForm/OrganizationForm';
import useOrganizationForm from 'hooks/useOrganizationForm';
import { useOrganizationsContext } from 'components/Organizations/OrganizationsProvider';

export const BusinessInfoContent: React.FC = () => {
    const {
        accounts,
        isAddAccountModalOpen,
        handleCloseModal,
        handleSaveChildOrganizationAccount,
        editingAccount,
        setEditingAccount
    } = useOrganizationsContext();
    const {
        setFormData,
        formData,
        errors,
        isSaving,
        handleInputChange,
        handlePhoneBlur,
        handleSave,
        parentOrganizations,
        parentOrganization,
        businessTypeOptions
    } = useOrganizationForm({
        isAddAccountModalOpen,
        handleCloseModal,
        editingAccount,
        accounts,
        handleSaveChildOrganizationAccount,
        isParentOrganization: true, // Editing the parent organization
        closeModalAfterSave: false // Don't close settings modal after saving
    });

    useEffect(() => {
        if (parentOrganization) {
            // Set the parent organization as the editing account
            setEditingAccount(parentOrganization);

            setFormData(data => ({
                ...data,
                parentOrganizationId: undefined,
                name: parentOrganization.name || '',
                nicknameDba: parentOrganization.nicknameDba || '',
                taxId: parentOrganization.taxId || '',
                businessType: parentOrganization.businessType || '',
                email: parentOrganization.email || '',
                phone: parentOrganization.phone || '',
                website: parentOrganization.website || '',
                addressLineOne: parentOrganization.addressLineOne || '',
                addressLineTwo: parentOrganization.addressLineTwo || '',
                city: parentOrganization.city || '',
                state: parentOrganization.state || '',
                zipcode: parentOrganization.zipcode || '',
                country: parentOrganization.country || ''
            }));
        }
    }, [parentOrganization, setEditingAccount, setFormData]);

    return (
        <div className={styles.businessInfoContent}>
            <div className={styles.header}>
                <h1 className={styles.title}>Business Info</h1>
            </div>
            {formData.businessType && (
                <div className={styles.content}>
                    <OrganizationForm
                        isParentOrganization={true}
                        formData={formData}
                        parentOrganizations={parentOrganizations}
                        businessTypeOptions={businessTypeOptions}
                        errors={errors}
                        onInputChange={handleInputChange}
                        onPhoneBlur={handlePhoneBlur}
                        onSave={handleSave}
                        editingAccount={editingAccount}
                        isSaving={isSaving}
                    />
                </div>
            )}
        </div>
    );
};

export default BusinessInfoContent;
